import { render, staticRenderFns } from "./PhuCard.vue?vue&type=template&id=f24aca48&scoped=true"
import script from "./PhuCard.vue?vue&type=script&lang=js"
export * from "./PhuCard.vue?vue&type=script&lang=js"
import style0 from "./PhuCard.vue?vue&type=style&index=0&id=f24aca48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24aca48",
  null
  
)

export default component.exports